/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_TitleInputs */

const da_legal_privacy_title = /** @type {(inputs: Legal_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlivspolitik`)
};

/** @type {(inputs: Legal_Privacy_TitleInputs) => LocalizedString} */
const en_legal_privacy_title = da_legal_privacy_title;

/**

* @param {Legal_Privacy_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_title = /** @type {((inputs?: Legal_Privacy_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_privacy_title(inputs)
	return /** @type {LocalizedString} */ ("Privatlivspolitik")
});